import { Link } from 'react-router-dom';
import { BreadcrumbItem, Breadcrumbs, Tooltip } from '@heroui/react';
import { Svg } from '@/shared/ui/Svg';
import ChevronLeftIcon from '@/shared/assets/icons/chevron-left.svg';

export interface IBreadcrumbItem {
  label: string;
  href?: string;
  tooltip?: string;
}

interface ICustomBreadcrumbsProps {
  items: IBreadcrumbItem[];
  className?: string;
}

export const CustomBreadcrumbs = ({ items, className }: ICustomBreadcrumbsProps) => (
  <Breadcrumbs
    className={className}
    itemClasses={{
      item: 'text-2xl text-black font-medium data-[current=true]:text-grey-secondary ',
      separator: 'pt-1',
    }}
    separator={<Svg Icon={ChevronLeftIcon} className="text-black" />}
  >
    {items.map(({ label, href, tooltip }, index) => {
      const isLast = index === items.length - 1;
      const content = href && !isLast ? <Link to={href}>{label}</Link> : label;

      return (
        <BreadcrumbItem key={`${label}-${href ?? 'current'}`}>
          {tooltip ? (
            <Tooltip content={tooltip} placement="top">
              {content}
            </Tooltip>
          ) : (
            content
          )}
        </BreadcrumbItem>
      );
    })}
  </Breadcrumbs>
);
